import { Calendar } from 'ui';
import type { CalendarSearchParamsOptions, CalendarSetting, Mode } from '../../../types';
import { Requests } from './requests';

type P = {
  date: CalendarSetting['date'];
  getPathToEventDetail: (id: string) => string;
  isOpen: boolean;
  mode: Mode;
  updateSearchParams: CalendarSearchParamsOptions['updateSearchParams'];
};

const SidePanel = ({ date, getPathToEventDetail, isOpen, mode, updateSearchParams }: P) => (
  <div aria-hidden={!isOpen} className="calendar-side-panel" inert={!isOpen}>
    <Calendar
      hideModeSwitch
      onChange={(newDate) => {
        updateSearchParams({ date: newDate });
      }}
      selectionMode={mode}
      value={date}
    />
    <Requests getPathToEventDetail={getPathToEventDetail} />
  </div>
);

export default SidePanel;
